import { render } from "./AppHeader.vue?vue&type=template&id=b679eca8&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=ts"
export * from "./AppHeader.vue?vue&type=script&lang=ts"

import "./AppHeader.vue?vue&type=style&index=0&id=b679eca8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b679eca8"

export default script